<div class="item-grid-container shadow">
  <div class="loyalty-reports-holder">
    <div class="search-holder">
      <ul class="list-inline grid-top-actions mb-3">
        <li class="list-inline-item ">
          <div class="search-holder">
            <input
              type="text"
              placeholder="{{ 'pages.newRetailer.search' | translate }}"
              matInput
              class="
                rounded-pill
                px-3
                py-2
                mb-0
                border-0
                bg-light
                w-100
                me-0
                input-search
                ms-3
              "
              (keyup)="quickSearch()"
              [(ngModel)]="searchValue"
            />
            <i
              color="primary"
              class="search-icon-holder"
              matSuffix
              mat-icon-button
              aria-label="Search"
            >
              <mat-icon>search</mat-icon>
            </i>
          </div>
        </li>
        <!-- <li class="list-inline-item">
                  <h4 class="transaction-dates">{{transactionFromDate}} - {{transactionToDate}}</h4>
                </li>
                <li class="list-inline-item">
                  <div class="calendar-btn">
                    <input
                      matInput
                      [matDatepicker]="dpFrom"
                      disabled
                      
                      [min]="minFromDate"
placeholder="MM/DD/YYYY"
                      [max]="maxDate"
                      (dateChange)="changeFromDate($event)"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="dpFrom"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
                  </div>
                </li>
                <li class="list-inline-item">
                  <div class="calendar-btn">
                    <input
                      matInput
                      [matDatepicker]="dpTo"
                      disabled
                      
                      [min]="minToDate"
placeholder="MM/DD/YYYY"
                      [max]="maxDate"
                      (dateChange)="changeToDate($event)"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="dpTo"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dpTo disabled="false"></mat-datepicker>
                  </div>
                </li> -->
        <li class="list-inline-item">
          <p class="small text-danger ms-auto desc-txt" >{{disclaimerText}}</p>
        </li>
                <li class="list-inline-item float-end">
          <button [disabled]="isButtonDisabled" mat-stroked-button class="bg-theme" (click)="createbatch()">
            <i class="mi mi-add smaill-icon"></i>
            <span translate class="translate"
              >pages.newRetailer.createBatch</span
            >
          </button>
        </li>
      </ul>
    </div>

    <div class="realtime-transactions-grid-container mt-3">
      <ag-grid-angular
        style="width: 100%; height: 60vh"
        class="ag-theme-material"
        [rowHeight]="40"
        [enableFilter]="true"
        [enableSorting]="true"
        [enableColResize]="true"
        [rowSelection]="'single'"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
      >
      </ag-grid-angular>
    </div>
  </div>
</div>
